import { render, staticRenderFns } from "./deductionDetail.vue?vue&type=template&id=13568b84&scoped=true"
import script from "./deductionDetail.vue?vue&type=script&lang=js"
export * from "./deductionDetail.vue?vue&type=script&lang=js"
import style0 from "./deductionDetail.vue?vue&type=style&index=0&id=13568b84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13568b84",
  null
  
)

export default component.exports